import type { AppAssetsConfig } from '@zto/zpage'

export const assets: AppAssetsConfig = {
  images: {
    logo: '/images/logo.png',
    welcome: '/images/welcome.png',
    changePositionImg01: '/images/change-user-position/01.png',
    changePositionImg02: '/images/change-user-position/02.png'
  },

  import_templates: {
    operate_objective_cityIndex: {
      name: '批量发货模板',
      url: '/templates/批量发货模板.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'shipmentCode' },
        { prop: 'expressName' },
        { prop: 'waybillNo' },
        { prop: 'receiveProvince' },
        { prop: 'receiveCity' },
        { prop: 'receiveDistrict' },
        { prop: 'receiveAddress' },
        { prop: 'receiveShopCode' },
        { prop: 'receiveShopName' },
        { prop: 'receiveName' },
        { prop: 'receiveMobile' }
      ]
    },
    import_shop_config: {
      name: '批量导入门店配置模版',
      url: '/templates/批量导入门店配置模版.xlsx',
      fileType: 'xlsx',
      columns: [{ prop: 'shopCode' }, { prop: 'mktStaySeconds' }],
      extraTip: {
        html: {
          tag: 'div',
          props: { style: { color: '#f6b605' } },
          children: [{ tag: 'span', children: ['如果导入了重复的门店编号，将会覆盖原记录'] }]
        }
      }
    },

    import_shop_list: {
      name: '门店批量导入模板',
      url: '/templates/门店批量导入模板.xlsx',
      fileType: 'xlsx',
      columns: [
        { prop: 'shopCode' },
        { prop: 'shopName' },
        { prop: 'provinceStr' },
        { prop: 'cityStr' },
        { prop: 'districtStr' },
        { prop: 'detailAddress' },
        { prop: 'contactName' },
        { prop: 'contactPhone' },
        { prop: 'gridCount' },
        { prop: 'dailyParcelEstimate' },
        { prop: 'channelCode' }
      ]
    }
  }
}
